import React from "react";

// importando o swiper
import { Swiper, SwiperSlide } from "swiper/react";

// importando os estilos do swiper
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../swiper.css";

// modulos necessários do swiper
import { Pagination, Navigation, Autoplay } from "swiper";

// importando dados
import { heroSlider } from "../data";

const HeroSlider = () => {
  return (
    <Swiper 
    modules={[Pagination, Navigation, Autoplay]}
    //  autoplay={true}
    //  loop={true}
     pagination={{
      clickable: true,
      dynamicMainBullets: true,
     }}
     navigation={true}
     className="heroSlider"
     >
      {heroSlider.map((slide, index) => {
        const { title, subtitle, image } = slide;
        return (
          <SwiperSlide key={index} className="py-12 lg:py-16">
            <div className="container mx-auto text-center lg:text-left">
              <div className="flex flex-col justify-between items-center lg:flex-row">
                <div className="flex-1">
                  <h1 className="text-orange text-[56px] leading-tight lg:text-[72px] lg:leading-[98px] font-extrabold mb-4">
                    {title}
                  </h1>
                  <p className="text-justify text-base lg:text-[18px] lg:leading-8 max-w-[540px] mb-8">
                    {subtitle}
                  </p>
              
                </div>

                <div className="flex-1 flex justify-center mb-20">
                  <img src={image.type} alt="Dog" className="h-200 lg:h-auto" />
                </div>
              </div>
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default HeroSlider;
